<template>
  <div class="subView">
    <div class="subView_list">
      <div class="subView_item">
        <div class="title">概述</div>
        <div class="border"></div>
        <div class="text">HashStor是构建分布式存储网络的存储设备，其目标是铺设全球存储网络，打造区块链应用生态，真正实现从数据互联到价值互联。</div>
      </div>
      <div class="subView_item">
        <div class="title">
          产品特性
        </div>
        <div class="border"></div>
        <div class="list">
          <div class="item center">
            <div class="item_img">
              <img src="../../assets/scheme/baas_40.png" alt="" style="width: 305px">
            </div>
            <div class="item_text01">
              性价比高
            </div>
          </div>
          <div class="item center">
            <div class="item_img">
              <img src="../../assets/scheme/baas_41.png" alt="" style="width: 305px">
            </div>
            <div class="item_text01">
              整体架构完全自主设计
            </div>
          </div>
          <div class="item center">
            <div class="item_img">
              <img src="../../assets/scheme/baas_42.png" alt="" style="width: 305px">
            </div>
            <div class="item_text01">
              可作为多种区块链基础设施 或分布式存储网络的节点
            </div>
          </div>
        </div>

        <div class="text">
          目前HashStor主要包括家庭经济版、家庭豪华版、企业经济版和企业豪华版4个版本，分别支持4盘位、16盘位、48盘位、80盘位硬盘。
        </div>
        <div class="list center">
          <div class="item">
            <div class="item_img">
              <img src="../../assets/scheme/baas_38.png" alt="" style="width: 223px;border-radius: 8px">
            </div>
            <div class="item_text">
              HashStor <span class="blue"> H1 </span> 40
            </div>
          </div>
          <div class="item">
            <div class="item_img">
              <img src="../../assets/scheme/baas_37.png" alt="" style="width: 223px;border-radius: 8px">
            </div>
            <div class="item_text">
              HashStor <span class="blue"> H2 </span> 160
            </div>
          </div>
          <div class="item">
            <div class="item_img">
              <img src="../../assets/scheme/baas_36.png" alt="" style="width: 223px;border-radius: 8px">
            </div>
            <div class="item_text">
              HashStor <span class="blue"> E1 </span> 480
            </div>
          </div>
          <div class="item">
            <div class="item_img">
              <img src="../../assets/scheme/baas_39.png" alt="" style="width: 223px;border-radius: 8px">
            </div>
            <div class="item_text">
              HashStor <span class="blue"> E2 </span> 800
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "hashstor",
  }
</script>

<style scoped lang="scss">
  .subView{
    .subView_list{
      margin: 85px 84px 100px;
      .subView_item{
        .title {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #282F3C;
          margin-left: 9px;
        }
        .border {
          width: 27px;
          height: 3px;
          margin-top: 3px;
          background-color: #056DFF;
        }
        .text {
          display: flex;
          flex-wrap: wrap;
          padding-bottom: 30px;
          font-size: 15px;
          margin: 20px 0;
          line-height: 45px;

        }
      }
      .list {
        display: flex;
        .item {
          flex: 0.3;
          margin-top: 30px;
          &:last-child {
            margin-right: 0;
          }
          .item_img {
            padding-bottom: 30px;
            text-align: center;
          }
          .item_img img {
            /*width: 355px;*/
            margin-right: 30%;
          }
          .item_text {
            width: 200px;
            color: #333;
            margin-left: 50px;
            font-size: 14px;
            line-height: 23px;
            text-align: left;
          }
          .item_text01{
            color: #333;
            font-size: 14px;
            line-height: 23px;
            text-align: left;
          }
        }
      }
      .center {
        text-align: center;
      }

      .blue {
        color: #2A67E3 !important;
      }
    }
  }
</style>
